export default __webpack_public_path__ + "img/5595623e153eaf1faa763535870c41f4.png";